import React from 'react'
import {Button, Checkbox, Form, Icon, Input, message} from 'antd'
import {connect} from 'react-redux'
import {Layout} from 'antd'

import logo from './logo-greener.png'

import {hideMessage, showAuthLoader, userSignIn} from 'appRedux/actions/Auth'

import CircularProgress from 'components/CircularProgress/index'

const FormItem = Form.Item
const {Footer} = Layout

class SignIn extends React.Component {
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage()
      }, 100)
    }
    if (this.props.authUser !== null) {
      this.props.history.push('/');
      console.log("Auth", this.props.authUser);
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.showAuthLoader()
        this.props.userSignIn(values) // action
      }
    })
  }

  render() {
    const {getFieldDecorator} = this.props.form
    const {showMessage, loader, alertMessage} = this.props

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-wid">
                <img className="logo-padding" alt="example"  src={logo} />
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form
                onSubmit={this.handleSubmit}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        required: true,
                        type: 'email',
                        message: 'Ingresa un correo electrónico válido!',
                      },
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon type="user" style={{color: 'rgba(0,0,0,.25)'}} />
                      }
                      placeholder="Correo"
                    />,
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [
                      {required: true, message: 'Ingresa tu contraseña!'},
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}} />
                      }
                      type="password"
                      placeholder="Contraseña"
                    />,
                  )}
                </FormItem>

                <FormItem>
                  <Button type="primary" htmlType="submit">
                    Ingresar
                  </Button>
                </FormItem>
              </Form>
              <Footer>
                <span className="gx-text-light gx-fs-sm">
                  Copyright Greener © 2019
                </span>
              </Footer>
            </div>

            {loader ? (
              <div className="gx-loader-view">
                <CircularProgress />
              </div>
            ) : null}
            {showMessage ? message.error(alertMessage.toString()) : null}
          </div>
        </div>
      </div>
    )
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn)

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth
  return {loader, alertMessage, showMessage, authUser}
}

export default connect(
  mapStateToProps,
  {
    userSignIn,
    hideMessage,
    showAuthLoader,
  },
)(WrappedNormalLoginForm)



// WEBPACK FOOTER //
// ./src/containers/SignIn.js